import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportSourcesOptionComponent } from '../../../shared/components/report-sources-option/report-sources-option.component';
import { ReportDateRangeOptionComponent } from '../../../shared/components/report-date-range-option/report-date-range-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedSourcesOptionComponent } from '../../../shared/components/report-applied-sources-option/report-applied-sources-option.component';
import { ReportAppliedDateRangeOptionComponent } from '../../../shared/components/report-applied-date-range-option/report-applied-date-range-option.component';

@Component({
    templateUrl: './capture-admin-partner-portal-claim-report.component.html',
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportSourcesOptionComponent,
              ReportDateRangeOptionComponent,
              ReportDetailsTemplateDirective,
              ReportAppliedSourcesOptionComponent,
              ReportAppliedDateRangeOptionComponent]
})
export class CaptureAdminPartnerPortalClaimReportComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/partner_capture_reports`;
  reportsCountUrl = `${environment.captureApi.url}/partner_capture_reports/count`;

  filtersForm = this.formBuilder.group({
    sources: [null],
    verifiedDate: [null],
  });
}
